import { ApiResponse, PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import { CreateParticipantResourceDto, GetAllParticipantResoucesReq, ParticipantResourceDto, UpdateParticipantResourceDto } from "../../interfaces/participantResource/participantResource";
import { apiDelete, apiGet, apiPost, apiPut } from "../../utilities/api-client/apiRequest";
import { buildQuery } from "../../utilities/common/buildQueryParams";

export async function CreateParticipantResourceAsync(
    authToken: string,
    payload: CreateParticipantResourceDto
): Promise<ApiResponse<number>> {
    const apiUrl: string = `/ParticipantResources`;

    var res = apiPost<ApiResponse<number>>(
        apiUrl, payload, authToken
    )

    return res;
}


export async function GetAllParticipantResourceAsync(
    authToken: string,
    payload: GetAllParticipantResoucesReq
): Promise<ApiResponse<PagedResults<ParticipantResourceDto>>> {
    const queryString = buildQuery(payload);
    const apiUrl: string = `/ParticipantResources/GetAllParticipantResources?${queryString}`;

    var res = apiGet<ApiResponse<PagedResults<ParticipantResourceDto>>>(
        apiUrl, authToken
    );

    return res;
}

export async function GetParticipantResourceByIdAsync(
    authToken: string,
    participantResourceId: string
): Promise<ApiResponse<ParticipantResourceDto>> {
    const apiUrl: string = `/ParticipantResources/${participantResourceId}`;

    var res = apiGet<ApiResponse<ParticipantResourceDto>>(
        apiUrl, authToken
    );

    return res;
}


export async function UpdateParticipantResourceAsync(
    authToken: string,
    payload: UpdateParticipantResourceDto
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/ParticipantResources/${payload.id}`;

    var res = apiPut<ApiResponse<string>>(
        apiUrl, payload, authToken
    )

    return res;
}

export async function ArchiveParticipantResourceAsync(
    authToken: string,
    ParticipantResourceId: string
): Promise<ApiResponse<string>> {
    const apiUrl: string = `/ParticipantResources/${ParticipantResourceId}`;

    var res = apiDelete<ApiResponse<string>>(
        apiUrl, {}, authToken
    )

    return res;
}